import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import http from "../../utils/axios";
import useToast from "../../utils/toast";
import { setLocalStorage, apiErrorMessage } from "../../utils/helpers";
import { useTranslation } from "react-i18next";

import useYupValidationResolver from "../../utils/yup";
import Layout from "../../components/common/Layout";
import { Button } from "@mui/material";
import FormInput from "../../components/form/Input";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

const ForgotPassword = () => {
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const toast = useToast();

  // validation form
  const validationSchema = yup.object({
    email: yup.string().email("Invalid Email").required(),
  });
  const resolver = useYupValidationResolver(validationSchema);

  const methods = useForm({
    resolver,
  });

  const { handleSubmit } = methods;

  const onSubmit = async (data) => {
    try {
      const res = await http.post("/forgot-password", data);
      if (res?.message) {
        // alert
        alert(t("login.check-email"));
        navigate("/login");
      }
    } catch (error) {
      const errorMessage = apiErrorMessage(error);
      if (errorMessage) {
        toast.error(errorMessage);
      } else {
        toast.error("Unknown Error");
      }
    }
  };

  return (
    <Layout>
      <div className="flex justify-center w-full">
        <div className="bg-white shadow-md rounded-md p-4 w-full sm:py-12 sm:px-16 sm:my-16 sm:w-3/5">
          <div>
            <Button className="p-0 capitalize" onClick={() => navigate(-1)}>
              <ChevronLeftIcon className="mr-2" />
              {t("back")}
            </Button>
          </div>
          <div className="text-center">
            <div className="text-3xl mb-2 capitalize">
              {t("login.forgot-password")}
            </div>
          </div>
          <form
            onSubmit={handleSubmit(onSubmit)}
            className="flex flex-col gap-4"
          >
            <FormInput
              methods={methods}
              name="email"
              label={t("email")}
              required
            />
            <div className="flex flex-col">
              <Button
                variant="contained"
                type="submit"
                className="capitalize"
              >
                {t("login.submit")}
              </Button>
            </div>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default ForgotPassword;
